import { ReferenceDataResponse } from "../response/reference-data-response";
import { GlossDateOld } from "../shared/gloss-date-old";

const UNDEFINED_BASE = "UNDEFINED_BASE";
export class ReferenceData {
  private readonly __v = 1;
  private _id: string;
  private _date: GlossDateOld;
  private _base: string;
  private _symbols: { [key: string]: number };

  constructor(response: ReferenceDataResponse) {
    if (response == null) {
      return;
    }

    this._date = response.glossDate;
    this._base = response.base ?? UNDEFINED_BASE;
    this._symbols = response.symbols;
    this._id = response.id ?? this.generateId();
  }

  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  get date(): GlossDateOld {
    return this._date;
  }

  set date(value: GlossDateOld) {
    this._date = value;
  }

  get base(): string {
    return this._base;
  }
  set base(value: string) {
    this._base = value;
  }

  get symbols(): { [p: string]: number } {
    return this._symbols;
  }
  set symbols(value: { [p: string]: number }) {
    this._symbols = value;
  }

  addSymbolRate(symbol: string, rate: number) {
    this._symbols[symbol] = rate;
  }

  private generateId() {
    if (this.date) {
      return `${this._base}@${GlossDateOld.getDateAsString(this._date)}`;
    }

    return `${this._base}@${GlossDateOld.getEpochDateTime()}`;
  }
}
